import React from 'react';
import { useLocation } from 'react-router';

import { MDText } from 'i18n-react';

import { EARLY_DOCS_START_PAGE } from 'Utilities/routing';

import { DocumentCaptureViewLayout } from '../../../DocumentCaptureView/DocumentCaptureView';
import { DocumentCaptureViewContainer } from '../../../shared/DocumentCaptureViewContainer/DocumentCaptureViewContainer';

import LocalTexts from './UploadDocumentsVerification.json';
import { UploadDocumentsVerificationEarlyDocs } from './UploadDocumentsVerificationEarlyDocs';
import { UploadDocumentsVerificationPostSale } from './UploadDocumentsVerificationPostSale';

const LocalT = new MDText(LocalTexts);

const contactInfo = {
  email: LocalT.translate('email') as string,
  phoneNumber: LocalT.translate('phoneNumber') as string,
};

export const UploadDocumentsVerification = () => {
  const { pathname } = useLocation();
  const isEarlyDocsFlow = pathname.includes(EARLY_DOCS_START_PAGE);

  if (isEarlyDocsFlow) {
    return (
      <DocumentCaptureViewLayout>
        <DocumentCaptureViewContainer isEarlyDocsFlow contactInfo={contactInfo}>
          <UploadDocumentsVerificationEarlyDocs />
        </DocumentCaptureViewContainer>
      </DocumentCaptureViewLayout>
    );
  }

  return (
    <UploadDocumentsVerificationPostSale />
  );
};
